"use client";

import { useConsentManager } from "@c15t/nextjs";
import type { ConsentCategory } from "../config/types";

export { useConsentManager as useConsent } from "@c15t/nextjs";

export const useHasConsent = (category: ConsentCategory) => {
  const { hasConsentFor } = useConsentManager();
  return hasConsentFor(category);
};
